import {OnInit, OnDestroy, Input, ElementRef, Output, EventEmitter, Component} from '@angular/core';
import {NDropComponent} from '../ndrop.component';

@Component({
  selector: 'n-drop-item',
  template: '',
  styles: [`:host{display:block;margin-top:16px;margin-right:20px}.fi-item{border-radius:6px;border:1px solid #e8eaed;overflow:hidden;width:195.73px}.fo-item{border-radius:6px;border:1px solid #e8eaed;overflow:hidden;width:193.656px}.n-file-preview{height:150px;border-bottom:1px solid #e8eaed}.n-name-block{min-width:200px;height:48px;display:flex;align-items:center;padding:10px;box-sizing:border-box}.n-name-block.n-name-active,.n-name-block.n-name-hover{background:#e8f0fe;z-index:1;color:#1967d2}.fi-item.n-item-hover{border-color:#1967d2}.fi-item.n-item-disabled{opacity:.4}.fo-item.n-item-hover{border-color:#1967d2}.fo-item.n-item-disabled{opacity:.4}span{font-family:Roboto,RobotoDraft,Helvetica,Arial,sans-serif;font-size:13px;color:rgba(0,0,0,.72);font-weight:400}.image-fit{height:147px;width:196px;-o-object-fit:cover;object-fit:cover;-o-object-position:center center;object-position:center center;-ms-interpolation-mode:nearest-neighbor;image-rendering:-moz-crisp-edges;image-rendering:-o-crisp-edges;image-rendering:pixelated}`]
})
export class NdropItemComponent implements OnInit, OnDestroy {

  @Input() fileNameField: string;
  @Input() data: any;
  @Input() active: boolean;
  @Input() disabled: boolean;
  @Output() selectionChange = new EventEmitter<any>();

  constructor(public elementRef: ElementRef, protected parentDropZone: NDropComponent) {
  }

  ngOnInit() {
    this.parentDropZone.registerItemComponent(this);
  }

  ngOnDestroy() {
    this.parentDropZone.unregisterItemComponent(this);
  }

  public select() {
    this.selectionChange.emit(this.data);
  }
}
